import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

export function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      // Show after a short delay so it doesn't flash on load
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    document.cookie = "cookie_consent=accepted;path=/;max-age=31536000;SameSite=Lax";
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    document.cookie = "cookie_consent=declined;path=/;max-age=31536000;SameSite=Lax";
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 lg:left-72 z-50 p-4 animate-in slide-in-from-bottom duration-300"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-3xl mx-auto bg-zinc-900 border border-zinc-700 rounded-xl p-5 shadow-2xl shadow-black/50">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <p className="text-white text-sm font-medium mb-1">We use cookies</p>
            <p className="text-zinc-400 text-xs leading-relaxed">
              We use essential cookies to keep you signed in and remember your preferences. 
              Read our{" "}
              <Link to="/cookies" className="text-emerald-500 hover:underline">Cookie Policy</Link>
              {" "}and{" "}
              <Link to="/privacy" className="text-emerald-500 hover:underline">Privacy Policy</Link>
              {" "}for details.
            </p>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={decline}
              className="text-zinc-400 hover:text-white text-xs h-8"
              data-testid="cookie-decline-btn"
            >
              Decline
            </Button>
            <Button
              size="sm"
              onClick={accept}
              className="bg-emerald-600 hover:bg-emerald-700 text-xs h-8"
              data-testid="cookie-accept-btn"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
